module.exports = __webpack_public_path__ + "static/media/zengarden.d5d5eaf6.png";